import React, { Fragment, } from "react";
import { Switch, Route } from "react-router-dom";

import Login from "./login/Login";
import License from "./license/License";
import NewCatch from "./newcatch/NewCatch";
import RegisterFisher from "./registerfisher/Registerfisher";
import History from "./history/History";
import RegisterUser from "./registeruser/Registeruser.js";
import FisherRecord from "./record/FisherRecord.js";
import AdminRecord from "./adminrecord/AdminRecord.js";
import UserAccounts from "./accounts/UserAccounts";
import UserCatchHistory from "./accounts/UserCatchHistory";
function Pages() {
 
    return (
      <Fragment>
        <Switch>
          <Route path="/" exact component={License} />
          <Route path="/login" component={Login} />
          <Route path="/registeruser" component={RegisterUser} />
          <Route path="/newcatch" component={NewCatch} />
          <Route path="/record" component={FisherRecord} />
          <Route path="/adminrecord" component={AdminRecord} />
          <Route path="/registerfisher" component={RegisterFisher} />
          <Route path="/history" component={History} />
          <Route path="/useraccounts" component={UserAccounts} />
          <Route path="/usercatchhistory" component={UserCatchHistory} />
        </Switch>
      </Fragment>
    );
  }


export default Pages;
